import classNames from 'classnames'

import { Tooltip } from 'core-components/library/tooltip'

import { INoteWrapperProps } from './models'

import styles from './NoteWrapper.module.scss'

export const NoteWrapper = ({
  noteContent,
  children,
  color = 'white',
  className,
  isHide,
}: INoteWrapperProps) => {
  if (!noteContent || isHide) {
    return children
  }

  const mods = {
    [styles.whiteIcon]: color === 'white',
    [styles.darkIcon]: color === 'dark',
  }
  return (
    <div className={classNames(styles.item, className)}>
      <div className={styles.itemFirst}>{children}</div>
      <Tooltip className={styles.itemLast} tipContent={noteContent}>
        <i className={classNames('kbase kbase-info-alt', styles.icon, styles.info, mods)} />
      </Tooltip>
    </div>
  )
}
